"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsMobile = void 0;
var _react = require("react");
const useIsMobile = width => {
  const getSize = () => {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  };
  const [windowSize, setWindowSize] = (0, _react.useState)(getSize);
  (0, _react.useEffect)(() => {
    const handleResize = () => {
      setWindowSize(getSize());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize.width <= (width ? width : 768);
};
exports.useIsMobile = useIsMobile;